import { render, staticRenderFns } from "./index.vue?vue&type=template&id=07e172ce&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=07e172ce&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e172ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07e172ce')) {
      api.createRecord('07e172ce', component.options)
    } else {
      api.reload('07e172ce', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=07e172ce&scoped=true", function () {
      api.rerender('07e172ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/BjRouteTabs/index.vue"
export default component.exports